<template>
    <span @click="handleClick" v-html="element.html"></span>
</template>
<script>
    import handleAction from "@mixins/HandleAction";

    export default {
        name:'Hotspot',
        props:{
            element:{
                required: true,
                type: Object
            }
        },
        mixins:[
            handleAction
        ],
    }
</script>
<style scoped>
    span {
        display: block;
        cursor: pointer;
        height:100%;
        width: 100%;
    }
</style>